import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();

/***
 * common api
 */

// 获取企业 通过企业类型
export function getUser_organization(parmas) {
    /**
     * 获取企业
     * @param {object} params
     */
    return api.get('/api/user_organization', parmas)
}
